/**
 * /intent · M02 意图管理（S2 Day 6b · T11 §3.2 路由 → M02）
 *
 * 三 tab：Intent 列表 / L2 YAML 编辑 / L1 Prompt 维护
 * 承接 M02 README 四子页规划（批量回归后置 W2 Day 8 · 本 PR 不交付）
 */
import { createFileRoute, useRouterState } from "@tanstack/react-router";

import { M02Shell, type M02View } from "@/components/m02/m02-shell";
import { PageHeader, type PageHelp } from "@/components/shared/page-help";

export const Route = createFileRoute("/intent")({
	component: IntentPage,
});

function IntentPage() {
	const view = getIntentView(useRouteHash());
	const copy = INTENT_VIEW_COPY[view];

	return (
		<div className="space-y-4">
			<PageHeader
				moduleId="M02"
				title={copy.title}
				description={copy.description}
				help={copy.help}
			/>
			<M02Shell view={view} />
		</div>
	);
}

function useRouteHash() {
	const routeHash = useRouterState({ select: (state) => state.location.hash });
	if (routeHash) return routeHash;
	if (typeof window === "undefined") return "";
	return window.location.hash;
}

function getIntentView(hash: string): M02View {
	const normalized = hash.replace(/^#/, "");
	return normalized === "intent-test" ? "test" : "management";
}

const intentHelpSections: PageHelp["sections"] = [
	{
		title: "这个页面用来做什么",
		items: [
			"查看系统支持的客户问题类型。",
			"维护已真实影响主链路的 L2 规则和 L1 Prompt 模板。",
			"改完规则后回到分类测试和评测运营页面跑样本，确认分类没有变差。",
		],
	},
	{
		title: "常见误判",
		items: [
			"命中分类不等于最终回复正确，还要继续看处理方案、工具事实和质量检查。",
			"L1 Prompt 模板保存后会影响后续 L1 分类；商户灰度只能选择已存在的模板版本。",
			"分类测试只看本环节结果，不替代端到端链路测试。",
		],
	},
];

const INTENT_VIEW_COPY: Record<
	M02View,
	{
		title: string;
		description: string;
		help: PageHelp;
	}
> = {
	management: {
		title: "分类管理",
		description: "维护客户意图、分类规则和灰度边界。",
		help: {
			title: "分类管理说明",
			description: "这里决定客户原话会先进入哪一类问题，是后续方案匹配和回复生成的第一道门。",
			sections: intentHelpSections,
		},
	},
	test: {
		title: "分类测试",
		description: "用模拟问题验证客户意图是否识别正确。",
		help: {
			title: "分类测试说明",
			description: "这里用于单独验证意图分类效果，并把结果带入评测运营继续闭环。",
			sections: intentHelpSections,
		},
	},
};
